import { createStyles, makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    // 編集ボタンの設定
    editStyle: {
      backgroundColor: '#007dff',
      color: '#fff',
      '&:hover': {
        backgroundColor: '#2691ff',
        boxShadow: 3
      },
      marginRight: 10
    },

    // 削除ボタンの設定
    deleteStyle: {
      backgroundColor: '#007dff',
      color: '#fff',
      '&:hover': {
        backgroundColor: '#2691ff',
        boxShadow: 3
      },
      marginRight: 10
    },
    // リンクボタンの設定
    linkStyle: {
      backgroundColor: '#007dff',
      color: '#fff',
      '&:hover': {
        backgroundColor: '#2691ff',
        boxShadow: 3,
        color: '#ffffff'
      },
      marginRight: 10
    }
  })
);
